// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".confirm-text[data-v-aa23da18]{max-width:305px;font-size:24px;margin:0 auto;font-weight:500}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
